module.exports = __webpack_public_path__ + "img/flip_cam.6061506b.svg";